/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: flex;
  flex-direction: column;
}

:host([bordered]) {
  box-shadow: inset 0 1px 0 var(--calcite-color-border-1);
  background-color: var(--calcite-color-foreground-1);
}
:host([bordered]) section {
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-1);
}

:host([bordered][position=bottom]) {
  box-shadow: inset 0 1px 0 var(--calcite-color-border-1), inset 0 -1px 0 var(--calcite-color-border-1);
}

:host([bordered]:not([position=bottom])) ::slotted(calcite-tab-nav) {
  margin-block-end: -1px;
}

:host([bordered][scale=s]) section {
  padding: 0.75rem;
}

:host([bordered][scale=m]) section {
  padding: 0.5rem;
}

:host([bordered][scale=l]) section {
  padding: 1rem;
}

:host([position=bottom]) {
  flex-direction: column-reverse;
}

section {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  border-block-start-width: 1px;
  border-block-start-color: var(--calcite-color-border-1);
  border-block-start-style: solid;
}

:host([position=bottom]) section {
  flex-direction: column-reverse;
  border-block-start-width: 0px;
  border-block-end-width: 1px;
  border-block-end-color: var(--calcite-color-border-1);
}

:host([position=bottom]:not([bordered])) section {
  border-block-end-style: solid;
}

@media (forced-colors: active) {
  :host([bordered]) section {
    border-block-start-width: 0px;
    border-block-end-width: 1px;
  }
  :host([position=bottom][bordered]) section {
    border-block-start-width: 1px;
    border-block-end-width: 0px;
  }
}
:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}